var React = require('react');

function FlagBs (props) {
    return React.createElement("svg",props,[React.createElement("g",{"fill":"#82afff","key":0},React.createElement("path",{"d":"M512 200.093H0V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828L512 200.093zM503.172 423.725H8.828A8.829 8.829 0 010 414.897V311.909h512v102.988a8.828 8.828 0 01-8.828 8.828z"})),React.createElement("path",{"fill":"#ffe15a","d":"M0 200.091h512v111.81H0z","key":1}),React.createElement("path",{"d":"M3.256 421.591l202.841-161.015c2.946-2.338 2.946-6.812 0-9.151L3.256 90.411C1.311 92.03 0 94.376 0 97.104v317.793c0 2.729 1.311 5.075 3.256 6.694z","fill":"#464655","key":2})]);
}

FlagBs.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagBs;

FlagBs.default = FlagBs;
